import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { translate as t } from "../../../../../../../infrastructure/translate/localization";
import useStyles from "../../styles";
import CobeeTextField from "../../../../../CobeeTextField";

export default function RowPurchasePrice({
  purchasePrice,
  setPurchasePrice,
}: {
  purchasePrice: string | number;
  setPurchasePrice(e: any): void;
}): JSX.Element {
  const { secondColumn, fieldRowSpacing, inputLabel } = useStyles();
  return (
    <>
      <Grid item xs={6} container alignItems="center">
        <Typography variant="body2">
          {t("request-section.purchase-price")}:
        </Typography>
      </Grid>
      <Grid
        item
        xs={6}
        container
        alignItems="center"
        className={`${secondColumn} ${fieldRowSpacing}`}
      >
        <Grid item xs={4}>
          <CobeeTextField
            styleType="default"
            variant="outlined"
            type="number"
            minWidth="100%"
            min={0}
            max={999999}
            step="1"
            value={purchasePrice}
            onChange={(e) => setPurchasePrice(e.target.value)}
          />
        </Grid>
        <Grid item xs={8}>
          <Typography variant="body2" className={inputLabel}>
            {`EUR (${t("common-messages.tax-included")})`}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
}
